import type { SVGProps } from "react";
const SenecPictogramPencil = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.9999 6.58582L37.9029 31.4888L40.3743 41.3744L30.4887 38.903L28.2928 36.7071C27.9023 36.3166 27.9023 35.6834 28.2928 35.2929C28.6833 34.9024 29.3165 34.9024 29.707 35.2929L30.9999 36.5858L32.5857 35L13.9999 16.4142L12.4141 18L25.707 31.2929C26.0975 31.6834 26.0975 32.3166 25.707 32.7071C25.3165 33.0977 24.6833 33.0977 24.2928 32.7071L5.58569 14L12.9999 6.58582ZM10.9999 16.5858L15.5857 12L12.9999 9.41424L8.41412 14L10.9999 16.5858ZM16.9999 13.4142L15.4141 15L33.9999 33.5858L35.5857 32L16.9999 13.4142ZM36.4581 33.956L32.9559 37.4583L37.6255 38.6257L36.4581 33.956Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramPencil;
